import React from "react";

import Accordian from "./Accordian";
import Map from "./Map";

export default function WhitepaperLayout() {
  return (
    <div
      className=" w-full flex flex-col items-center justify-center text-white font-Helvetica
      scale-100 lg:scale-[0.8] xl:scale-[0.9] 2xl:scale-100  mx-auto overflow-hidden
    "
    >
      <div className="w-full text-center text-4xl lg:text-6xl font-Red-Undead uppercase
      pt-36 lg:pt-0  xl:pt-36 
      ">
        Whitepaper
      </div>
      <span className="lg:block ">
        <Map />
      </span>
      <Accordian />
    </div>
  );
}
